export default "/images/ete.svg?8813396b6c7ce24f76c29f41f119b7d1";